/*
 * @Author: lixiaoli lxl1596717219@163.com
 * @Date: 2023-04-03 11:21:54
 * @LastEditors: lixiaoli lxl1596717219@163.com
 * @LastEditTime: 2023-11-21 10:34:52
 * @FilePath: \visualization-platform-jiangsu\src\Serves\net-http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const ModeLocal=1 // 本地
const ModeNetest=2 // 生产环境
const ModeProduct=3
var RunMod = ModeProduct
// 测试
let test='' // 测试环境
let Login=''
let baseUrl=''
//生产
if(RunMod == ModeProduct){//生产环境
	// test='http://api-njjkht-sh.dtwl360.com'
	// test='http://api-njjkht-new.dtwl360.com'
	test='https://api-njjkht-pg.dtwl360.com' // 全国及各省
	// test = 'http://api-huaxia.dtwl360.com' //华夏省
}
//本地
else if(RunMod == ModeNetest){
	// test='http://192.168.0.60:28707' // 测试环境
}
const url={
  Login:Login,
  test:test,
  userVerify: test +'/SsoLoginZJ/userVerify',
  getPkAndUuid: test + '/account/noLogin/getPkAndUuid',
  gis:{
  	getBlockTrackList:test + '/gis/gps/getBlockTrackList',
  	queryLandInfo:test + '/workDataPc/queryLandInfo',
  	shangHaiBoundary:test + '/gis/gps/shangHaiBoundary',
  	queryNjNumAreaForBuyAndHistory: test + '/screenBuyNj/queryNjNumAreaForBuyAndHistory',
  	getCentroidList: test + '/gis/gps/getCentroidList',
  	getBlockListByEnvelope: test + '/gis/gps/getBlockListByEnvelope',
  	getIncrementalBlockList:test + '/gis/gps/getIncrementalBlockList',
    getHeatmapDataList:test + '/gis/gps/getHeatmapDataList',
  	getStatisticalWorkAreaData:test + '/gis/gps/getStatisticalWorkAreaData',
  	getTracklinestringList:test + '/gis/gps/getTracklinestringList',
  	findCurrrentGpsDataList:test + '/gis/gps/findCurrrentGpsDataList',
  	getCurrentGpsPointByViewExtend:test + '/gis/gps/getCurrentGpsPointByViewExtend',
  	getMarkerInfo:test + '/gis/gps/getMarkerInfo',
  	getAllGpsCurrentData:test + '/gis/gps/getAllGpsCurrentData',
  	work: test + '/track/listWorkTodayTrackIncremental',
  	gps: test + '/track/listGpsTodayTrackIncremental',
	findBlocks: test + '/purchaseSubsidyMonitor/findBlocks',
	getCountyBorderByViewCenter:test + '/gis/border/getCountyBorderByViewCenter',
	getCityBorderByViewCenter:test + '/gis/border/noLogin/getCityBorderByViewCenter',
	// 替换北京相应的接口
	getHeatmapDataBeijing:test + '/gis/gps/getHeatmapDataBeijing',
	getHeatmapDataByExtendBeijing:test + '/gis/gps/getHeatmapDataByExtendBeijing',
	newCountNjNumByMachineType:test + '/homePageStatis/newCountNjNumByMachineType',
	markerNjData:test +'/dtIotNjData/getDtIotNjDataAndCurrentData',
	countNjNumByDay:test + '/homePageStatis/countNjNumByDay',
	updateCurrentLocation:test +'/njInfo/updateCurrentLocation'
  },
  area: {
	getCountyList: test + '/area/getCountyOfCityAndProvice',
	townsList: test + '/common/townsList',
  },
  machinery: {
	allowanceList: test + '/nj/allowance-stock/statistics'
  },
  homePageStatis: {
	findEmissionReductionByRegion: test + '/emissionReduction/findEmissionReductionByRegion', // 减排机具地区分布
	statisticsERDeviceNum: test + '/homePageStatis/statisticsERDeviceNum' // 机具数量、作业面积、行驶里程、减排量统计接口
  },
  workSubsidy: {
	workSubStatistics: test + '/workSubsidy/workSubStatistics', //单独切换作业补贴统计模块
	workStatistics: test + '/workSubsidy/workStatistics', //作业补贴机具首页
	workTypeProportion: test + '/workSubsidy/workTypeProportion', //单独切换各作业类型占比
	workTypeList: test + '/common/workTypeList', //作业补贴类型列表
	workTypePlan: test + '/workSubsidy/workTypePlan', //单独切换各作业类型补贴进度
	njInfoInMap: test + '/common/njInfoInMap',
    workSubMapDistri: test + '/workSubsidy/workSubMapDistri', //单独切换作业补贴机具地图分布
    countByWorkType: test + '/homePage/countByWorkType', //各作业类型机具、面积、补贴总计
    workSubsidyList: test + '/workSubsidyList/workSubsidyList', //作业补贴机具列表
    workSubsidyDetails: test + '/workSubsidyList/workSubsidyDetails', //农机详情
    workSubsidyRecordList: test + '/workSubsidyList/workSubsidyRecordList', //作业记录列表
    // trackView: test + '/workSubsidyList/trackView',// 查看
    trackView: test + '/workSubsidyList/listWorkTrack',
    workPictureList: test + '/workSubsidyList/workPictureList', //作业图片
    listHistoryTrack: test + '/workSubsidyList/listHistoryTrack', //历史作业位置列表
    listHistoryCoord: test + '/workSubsidyList/listHistoryCoord'//历史作业位置坐标
  },
  homePageStatisByJSController:{
    countNjNumHeatMapStatis: test + '/homePageStatisByJSController/countNjNumHeatMapStatis',//农机数量统计
    countNjHeatMap: test + '/homePageStatisByJSController/countNjHeatMap',//农机热力图分布
    getCurrentGpsPoint: test + '/homePageStatisByJSController/getCurrentGpsPoint',//农机热力图分布
  }
}
export default url



// WEBPACK FOOTER //
// ./src/Serves/net-http.js